import Repository from '@/repositories/marketing'
const resource = '/cleansing_rules'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    create(config){
        return Repository.post(`${resource}.json`,config)
    },
    show(id, config){
        return Repository.get(`${resource}/${id}`,config)
    },
    edit(id, config){
        return Repository.put(`${resource}/${id}.json`,config)
    },
    delete(id){
        return Repository.delete(`${resource}/${id}.json`)
    },
    toggle(id, config){
        return Repository.put(`${resource}/${id}.json`, config)
    }
}